import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const StartIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.80945 1.10736L10.1127 5.31274C10.2213 5.68213 10.5471 5.92366 10.9136 5.92366H15.1492C15.9637 5.92366 16.3167 7.01762 15.6515 7.52909L12.2305 10.129C11.9318 10.3563 11.8096 10.7542 11.9182 11.1235L13.2215 15.3289C13.4794 16.1387 12.5834 16.8207 11.9182 16.3234L8.49722 13.7235C8.19856 13.4962 7.80487 13.4962 7.50621 13.7235L4.08521 16.3234C3.42001 16.8349 2.52404 16.1529 2.78197 15.3289L4.08521 11.1235C4.19381 10.7542 4.08521 10.3563 3.77297 10.129L0.351969 7.52909C-0.313227 7.01762 0.0261585 5.92366 0.854259 5.92366H5.08979C5.45633 5.92366 5.78214 5.68213 5.89074 5.31274L7.19398 1.10736C7.45191 0.297545 8.55152 0.297545 8.80945 1.10736Z"
        fill="currentCollor"
      />
    </svg>
  );
};

export default StartIcon;
